import TileWMS from "ol/source/TileWMS";
import { Tile as TileLayer } from "ol/layer";
import OlView from "ol/View";
import Projection from "ol/proj/Projection";
import { ol_layer_2 } from "../../../data/OlTileLayerConfig";
import { ol_view_2 } from "../../../data/OlViewConfig";

const { TileLayers } = ol_layer_2;

const layers = TileLayers.map(({ source, ...rest }) => {
  return new TileLayer({ source: new TileWMS(source), ...rest });
});

function id2Layers(vectors) {
  return [...layers, vectors];
}

const { code, units } = ol_view_2["projection"];

const projection = new Projection({
  code,
  units,
});

const id2View = new OlView({ ...ol_view_2, projection });

export { id2Layers, id2View };
